<template>
    <div>
      <div v-if="this.task.longitude != 0 && this.task.latitude !== 0 && this.task.latitude !== null && this.task.longitude !== null">
        <MglMap
                id="mapContainer"
                :accessToken="accessToken"
                :mapStyle="mapStyle"
                :center="location"
                :zoom="12"
                :scrollZoom="false"
                :navigationControl="true"
                >
            <MglNavigationControl position="top-right" />

            <MglMarker :coordinates="location" color="#1e345d" />
        </MglMap>
        </div>
        <div v-else>
            <v-flex xs12 sm12 md12 lg12 xl12 id="nonMapContainer">
              <p>Invalid Coordinates</p>
            </v-flex>
        </div>
        <v-layout row wrap class="pa-4">
            <v-flex xs5>
              <span class="font-weight-medium">Work Order #</span>
            </v-flex>
            <v-flex xs7 class="text-right">
              {{ `WO ${task.workOrder.workOrderNumber} - ${task.taskNumber}` }}
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
            <v-divider></v-divider>
            </v-flex>
            <v-flex xs5>
              <span class="font-weight-medium">ESO #</span>
            </v-flex>
            <v-flex xs7 class="text-right">
                {{ task.eso || 'N/A' }}
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs3>
              <span class="font-weight-medium">Address</span>
            </v-flex>
            <v-flex xs9 class="text-right">
                {{ task.address }}
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs5>
              <span class="font-weight-medium">ISD</span>
            </v-flex>
            <v-flex xs7 class="text-right">
                {{ task.isd.slice(0,10) }}
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 sm4 md4 lg4 xl4 class="start-date-col">
              <span class="font-weight-medium start-date-label">Start Date:&ensp;</span>
              <span class="start-date-value">{{ task.startDate.slice(0,10) }}</span>
            </v-flex>

            <v-flex xs12 sm4 md4 lg4 xl4 class="end-date-col">
              <span class="font-weight-medium end-date-label">End Date:&ensp;</span>
              <span class="end-date-value">{{ task.completionDate.slice(0,10) }}</span>
            </v-flex>

            <v-flex xs12 sm4 md4 lg4 xl4 class="duration-col">
              <span class="font-weight-medium duration-label">Duration:&ensp;</span>
              <span class="duration-value">{{ task.duration }}</span>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12 sm3 md3 lg3 xl3>
              <span class="font-weight-medium">Description</span>
            </v-flex>
            <v-flex xs12 sm9 md9 lg9 xl9>
              <div class="description-text-wrapper">
                {{ task.description }}
              </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import Mapbox from 'mapbox-gl'
import { MglMap, MglMarker, MglNavigationControl } from 'vue-mapbox'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'DetailView',
  components: {
    MglMap,
    MglNavigationControl,
    MglMarker
  },
  data: () => ({
    map: null,
    accessToken: 'pk.eyJ1Ijoicm9iY2xpZmZvcmQiLCJhIjoiY2p6eGJyNHlzMTV3MjNjbXYzbDV5dXZtNyJ9.beJcHjDQnuu9Lbkg0sJiug',
    mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
    coordinates: [-121.409, 49.700]
  }),
  created () {
    this.mapbox = Mapbox
  },
  methods: {
    ...mapActions({
      clearTask: 'workOrderTask/clearTask'
    })
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask'
    }),
    location () {
      return [this.task.longitude, this.task.latitude]
    }
  }
}
</script>
<style scoped>
#mapContainer {
    height: 190px;
}
#nonMapContainer {
  height: 190px;
  background-color: lightgrey;
  text-align: center;
  justify-content: center;
}
.start-date-col {
  text-align: left;
}
.end-date-col {
  text-align: center;
}
.duration-col {
  text-align: right;
}
.description-text-wrapper {
  float: right;
  text-align: left;
}
@media only screen and (max-width: 599px) {
  .start-date-col,
  .end-date-col,
  .duration-col {
    text-align: left;
  }
  .start-date-value,
  .end-date-value,
  .duration-value {
    float: right !important;
  }
  .description-text-wrapper {
    float: left;
  }
}
</style>
